import React, { Component } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import BetterBox from "../../../components/BetterBox";
import { mesesAbrev } from "../../../utils/Constants";
import { theme } from "../../../theme/colors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Tooltip,
  Legend
);

export default class GraficoViagensMes extends Component {
  constructor() {
    super();

    this.state = {
      data: null,
    };
  }

  componentDidMount = () => {
    this.formatarDados();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) {
      this.formatarDados();
    }
  };

  formatarDados = () => {
    if (!this.props.data || this.props.data.length === 0) {
      return;
    }

    const barColor = theme.secondaryColors[6];

    const data = {
      labels: this.props.data.map((itemDados) => this.formatarMes(itemDados.mes)),
      datasets: [
        {
          data: this.props.data.map((itemDados) => itemDados.total),
          backgroundColor: barColor,
          borderColor: barColor,
          borderWidth: 0,
        },
      ],
    };

    this.setState({ data });
  };

  formatarMes = (mesString) => {
    try {
      const parts = mesString.split("-");
      
      if (parts.length !== 2) return mesString;
      
      const [a, b] = parts;
      const ano = a.length === 4 ? a : b;
      const mesNum = a.length === 4 ? b : a;
      const anoCurto = ano.length >= 2 ? ano.slice(-2) : ano;
      
      return `${mesesAbrev[parseInt(mesNum, 10) - 1]}/${anoCurto}`;
    } catch (error) {
      return mesString;
    }
  };

  render() {
    if (!this.state?.data) {
      return <div>Carregando gráfico...</div>;
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          callbacks: {
            title: (context) => context[0].label,
            label: (context) => ` Viagens: ${context.parsed.y.toLocaleString("pt-BR")}`,
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            maxRotation: 0,
            minRotation: 0,
          },
        },
        y: {
          beginAtZero: true,
          grid: {
            color: "rgba(0, 0, 0, 0.06)",
          },
          ticks: {
            callback: function (value) {
              return value.toLocaleString("pt-BR");
            },
          },
        },
      },
    };

    return (
      <BetterBox title="Viagens realizadas por mês">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            aspectRatio: "3",
            maxWidth: "100%",
          }}
        >
          <Bar options={options} data={this.state.data} />
        </div>
      </BetterBox>
    );
  }
}
